var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('keep-alive',[_c(_vm.componentsId,{tag:"component",attrs:{"customerOldId":_vm.customerOldId,"customerNewId":_vm.customerNewId,"houseId":_vm.houseId}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51eec088","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/User/CustomerManagement/components/SaleCarryOver.vue
// module id = null
// module chunks = 